import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FiAlertCircle, FiHome } from 'react-icons/fi';
import { Button } from '@/components/ui/button';

const NotAuthorized = () => {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[calc(100vh-70px)] items-center justify-center bg-[#F4F7FE]">
      <div className="flex flex-col items-center gap-6 p-8 text-center">
        <FiAlertCircle className="h-24 w-24 text-red-500" aria-hidden />
        <h1 className="text-3xl font-bold text-slate-800">Akses Ditolak</h1>
        <p className="max-w-lg text-lg text-slate-600">
          Anda tidak memiliki akses ke halaman ini. Menu ini belum di-assign ke akun Anda. Silakan hubungi administrator untuk
          mendapatkan akses.
        </p>
        <Button size="lg" className="gap-2" onClick={() => navigate('/admin')}>
          <FiHome className="h-5 w-5" />
          Kembali ke Dashboard
        </Button>
      </div>
    </div>
  );
};

export default NotAuthorized;
